import { SparklesIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedArtifactDigestCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface ArtifactDigestCreatedEventProps {
  event: DiscriminatedArtifactDigestCreatedEvent;
}

export const ArtifactDigestCreatedEvent: React.FC<
  ArtifactDigestCreatedEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-100">
          <SparklesIcon className="h-4 w-4 text-indigo-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityTitle>{event.payload.title}</ActivityTitle>
      <ActivityDescription>
        <div className="text-xs">
          <span className="text-gray-500">Status: </span>
          <span className="text-gray-900">{event.payload.status}</span>
        </div>
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Document Analysis Complete"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
